import { useQuery } from "@tanstack/react-query";
import { apiFetch } from "@/lib/api";
import { submittalKeys } from "@/lib/query";

interface Submittal {
  id: string;
  projectId: string;
  number: string | null;
  title: string | null;
  specSection: string | null;
  status: string | null;
  submittedBy: string | null;
  dateSubmitted: string | null;
  dateRequired: string | null;
}

export type { Submittal };

export function useSubmittals(projectId?: string) {
  return useQuery({
    queryKey: [...submittalKeys.all, projectId],
    queryFn: () =>
      apiFetch<Submittal[]>(projectId ? `/submittals?projectId=${projectId}` : "/submittals"),
  });
}
